// eslint-disable-next-line no-unused-vars

// polyfills
import './polyfills/forEach' // IE fix forEach-function
import './polyfills/scrollingElement' // (?) fix scrolling
import vh_fix from './polyfills/vh_fix' // Smartphone fix 100vh

// gsap
import { gsap } from "gsap"; 
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

// paper.js
import paper_canvas from './components-lucasrees_com/paper_canvas';

// components
import scrolling from './components-lucasrees_com/scrolling';
import scrolltrigger from './components-lucasrees_com/scrolltrigger';
import interactive_title from './components-lucasrees_com/interactive_title';
import scroll_links from './components-lucasrees_com/scroll_links';

import WordShuffle from './components-lucasrees_com/word_shuffle_optimized';
import experience_icons from './components-lucasrees_com/experience_icons';
import encode_email from './components-lucasrees_com/encode_email';
// import accordions from './components-lucasrees_com/accordion';
import external_links from './components-lucasrees_com/external_links';

(() => {
    if ('ontouchstart' in document.documentElement) {
        document.body.classList.add('is-touch')
    }
    const { userAgent } = window.navigator;
    if (userAgent.indexOf('MSIE ') > 0 || userAgent.indexOf('Trident/') > 0) {
        document.body.classList.add('is-ie')
    }
})

document.addEventListener('DOMContentLoaded',(event) =>{
    let nav_querry = window.matchMedia("(min-width: 900px)")
    new vh_fix()
    new scrolling( gsap )
    new scrolltrigger( ScrollTrigger, nav_querry )
    new scroll_links( gsap )
}, false);

document.fonts.onloadingdone = () => {
    document.querySelector("body").classList.add("fontsready")
};

window.addEventListener('load', (event) => { 
    let nav_querry = window.matchMedia("(min-width: 900px)")
    /* color effect on intro */
    const classList = ["green", "blue", "yellow", "orange", "red", "pink", "plum"];
    document.querySelectorAll("#intro svg g").forEach(element => {
        element.addEventListener("mouseenter", () => {
            let randomClass;
            element.classList.remove(...element.classList);
            randomClass = classList[Math.floor(Math.random() * classList.length)];
            element.classList.add(randomClass);
        });
    });
    /* */
    new encode_email()
    new external_links()
    new experience_icons( gsap )
    document.querySelector("#robert_irwin .noise").classList.add('running')
    const paperCanvas = new paper_canvas( nav_querry )
    document.querySelector("#yayoi_kusama canvas").classList.add('running')
    /* paperCanvas.configurePixelTrail({
        pixelSize: 7,
        drawDuration: 800,
        dissolveSpeed: 10
    });
    paperCanvas.enablePixelTrail(); */
    new WordShuffle( ScrollTrigger )
    new interactive_title()
    // new accordions( gsap, ScrollTrigger )
    // new activity_clock()
});